<template>
  <div id="app" class="d-flex flex-column h-100">
    <o-pwa-updater></o-pwa-updater>
    
    <o-app-drawer
      :toolbar="buttonBarItems"
      :admin_items="admin_items"
      :items="filteredItems"
      hide-home
      hide-admin
      hide-top-items
    >
      <template v-slot:brand>
        <div>
          <div>
            <router-link to="/">
              <img
                src="@/assets/images/logo.png"
                height="30"
                width="200"
                alt=""
              />
            </router-link>
          </div>
        </div>
      </template>
      >
      <template v-slot:right-hand-side v-if="isLoggedIn">
        <notification></notification>
      </template>
    </o-app-drawer>

    <o-app-content margin-top="77px"></o-app-content>

    <o-app-footer :version="version" year="2020"></o-app-footer>
  </div>
</template>

<style>
#nprogress .bar {
  background: #1976d2 !important;
  height: 5px;
}

.white--text a {
  color: white;
}

.footer {
  white-space: nowrap;
}
</style>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import MENU_ITEMS from "./app/menu_items";
import ADMIN_ITEMS from "./app/admin_items";
import { filterMenuByPrefs } from "./app/menu_utils";
import OAppDrawer from "./vue-ocom/components/layout/app/OAppDrawer";
import OAppContent from "./vue-ocom/components/layout/app/OAppContent";
import OAppFooter from "./vue-ocom/components/layout/app/OAppFooter";
import OPwaUpdater from "./vue-ocom/components/layout/app/OPwaUpdater";
import Notification from "./vue-notifications/components/Notification";
import OButtonBar from "./app/components/OButtonBar";
import * as CONFIG from "./config.js";
// Toolbar icons
import ApplicationIcon from "vue-material-design-icons/AccountMultiple";
import ListIcon from "vue-material-design-icons/FormatListBulleted";
import SheetIcon from "vue-material-design-icons/GoogleSpreadsheet";
import DocumentIcon from "vue-material-design-icons/FileDocumentMultipleOutline";
import ForumIcon from "vue-material-design-icons/Forum";
import BusClockIcon from "vue-material-design-icons/BusClock";

Vue.component("ApplicationIcon", ApplicationIcon);
Vue.component("ListIcon", ListIcon);
Vue.component("SheetIcon", SheetIcon);
Vue.component("DocumentIcon", DocumentIcon);
Vue.component("ForumIcon", ForumIcon);
Vue.component("BusClockIcon", BusClockIcon);

export default {
  name: "App",
  components: { OAppContent, OAppFooter, OAppDrawer, OPwaUpdater, Notification, OButtonBar },
  data: () => ({
    admin_items: ADMIN_ITEMS,
    items: MENU_ITEMS,
    buttonBarItems: [
      { icon: "home", text: "Home", URL: "/" },
      {
        icon: "application",
        text: "Leave",
        URL: "/leave_request/list?filter=my_leave_requests&sort=created_date&order=desc",
      },
      { icon: "list", text: "Forms", URL: "/form_entry/create" },
      {
        icon: "sheet",
        text: "Runsheets",
        URL: "/library/category/33",
      },
      { icon: "document", text: "Documents", URL: "/library/list?limit=20" },
      {
        icon: "forum",
        text: "Inbox",
        URL: "/notification/inbox?filter=all&q=&searchField=&qbe=%7B%7D&offset=0&limit=10&sort=created_date&order=desc",
      },
      {
        icon: "bus-clock",
        text: "Driver Portal",
        URL: "https://portal.mcharrys.com.au/OperationsPortal/Login?returnUrl=https://portal.mcharrys.com.au/OperationsPortal/Allocations",
      },
    ],
    version: CONFIG.version,
  }),
  props: {
    source: String,
  },
  methods: {
    ...mapActions({ getAllPreferences: "PreferencesModule/getAll" }),
  },
  computed: {
    ...mapGetters("AuthModule", ["isLoggedIn"]),
    ...mapGetters({
      global_preferences: "PreferencesModule/global_preferences",
    }),
    filteredItems() {
      return filterMenuByPrefs(this.items, this.global_preferences);
    },
  },
  watch: {
    isLoggedIn: {
      handler(loggedIn) {
        if (loggedIn) {
          this.getAllPreferences();
        }
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener("beforeunload", function (event) {
      if (window.lockLeave === true) {
        event.preventDefault();

        event.returnValue = "";
      } else {
        return false;
      }
    });
  },
};
</script>
